import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  public message: string = this.route.snapshot.paramMap.get('message');

  constructor(protected route: ActivatedRoute) {}

  ngOnInit(): void {}
}
